import { ShepherdBase } from 'shepherd.js';

/**
 * Retrieves the list of tours that have been shown from localStorage.
 */
const getShownTours = () => JSON.parse(localStorage.getItem('shownTours')) || [];

const hasTourBeenShown = (tourId: string) => getShownTours().includes(tourId);

const markTourAsShown = (tourId: string) => {
  const shownTours = getShownTours();
  if (!shownTours.includes(tourId)) {
    shownTours.push(tourId);
    localStorage.setItem('shownTours', JSON.stringify(shownTours));
  }
};

const defaultShowHandler = (Shepherd: ShepherdBase) => {
  const currentStep = Shepherd.activeTour?.getCurrentStep();
  if (currentStep) {
    const progress = document.createElement('span');
    progress.className = 'shepherd-progress text-lg text-muted-foreground';
    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
    progress.style.position = 'absolute';
    progress.style.left = '13px';
    progress.style.bottom = '20px';
    progress.style.zIndex = '1';

    const footer = currentStep?.getElement()?.querySelector('.shepherd-footer');
    footer?.appendChild(progress);
  }
};

// No external floating-ui middleware — let shepherd use its own built-in
// positioning to avoid version conflicts between shepherd's internal
// bundled @floating-ui/dom and any externally imported version.
const middleware = [];

export { hasTourBeenShown, markTourAsShown, middleware, defaultShowHandler };
